import { Provider } from "react-redux";
import { store, persistor } from "./store";
import * as DXData from './components/Utils/js-bridge/DXData';
import React from 'react';
import ReactDOM from 'react-dom';
import { PersistGate } from 'redux-persist/integration/react';
import App from './App';

import './images/icons/favicon.ico'
import './assets/vendor_components/bootstrap/css/bootstrap.css';
import './css/master_style.css';
import './css/skins/_all-skins.css';



//import './css/main.css'
//import '../public/css/loginRole.css'
//import '../../ClientApp/public/css/loginRole.css'
import './css/loginRole.css'
//import './css/util.css'
//import 'devextreme/dist/css/dx.common.css';
//import 'devextreme/dist/css/dx.light.css';


//import 'devextreme/dist/js/dx.web'
//import './fonts/font-awesome-4.7.0/css/font-awesome.min.css'

import '../src/fonts/Roboto/css/Roboto.css'

ReactDOM.render(
    <Provider store={store}>
        <PersistGate persistor={persistor}>
            <App />   
        </PersistGate>
    </Provider>, 
    document.getElementById('root')
);




// WEBPACK FOOTER //
// ./src/index.js